import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { NTH_USER_AUTO_FOLLOW_TEAMMATES } from '../../constants/onboarding-state/onboarding-constants.ts';
import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadAutoFollowTeammatesState = () => {
	return waitForAllReturnWhenError([
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: getOnboardingStateGQL,
			variables: {
				key: Object.values(NTH_USER_AUTO_FOLLOW_TEAMMATES),
			},
		}),
	]);
};
